import { format, parseISO } from 'date-fns';
import { createRoot } from 'react-dom/client';
import {
  MEAT_TAGS,
  SHELLFISH_TAGS,
  SOY_TAGS,
  SEAFOOD_TAGS,
  SPICY_TAGS_MAP,
} from './constants.js';

// this allow us to render the app only id the dom element exists on the page.
export function renderApp(component, id) {
  let domElement = document.getElementById(id);
  if (!domElement) return;
  createRoot(domElement).render(component);
}

export function getCurrentPathName() {
  let pathname = window.location.pathname;
  return pathname[pathname.length - 1] !== '/' ? `${pathname}/` : pathname;
}

export const getPairingDataImg = (pd, src) => {
  let cssValue = src === 'src' ? pd.featured_img : `url(${pd.featured_img})`;
  return pd.featured_img ? cssValue : null;
};

export const deepCloneObj = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

export const commaNumber = (n) =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

// paramenter should be a word or 2 words separated by a symbol
export const capitalize = (s) => {
  let match = s.match(/\W/);
  let symbol = match ? s.match(/\W/)[0] : ' ';
  let arrOfWords = s.split(symbol);
  let capitalizedWords = arrOfWords.map((word) => {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  });
  return capitalizedWords.join(symbol);
};

// This creates component Selector options object from an array of objects
// example: {value: [primitive], optionText[string]: , img: [string]}
/**
 *
 * @param { array of objects to make into selector options } arr
 * @param {{ uppercase: type bool, uppercase: type bool }} options
 * @returns
 */
export const createSelectorOptions = (
  arr,
  valueKey,
  optionTextKey,
  imgKey,
  subtext,
  options = {}
) => {
  if (!Array.isArray(arr)) {
    arr = Object.values(arr);
  }
  return arr.reduce((acc, nextOption) => {
    acc[nextOption[valueKey]] = {
      value: nextOption[valueKey],
      optionText:
        nextOption[optionTextKey] && options.uppercase
          ? nextOption[optionTextKey].toUpperCase()
          : nextOption[optionTextKey],
      img: nextOption[imgKey],
      subtext: nextOption[subtext],
    };
    if (options.optionHTML) {
      acc[nextOption[valueKey]]['optionHTML'] =
        nextOption[optionTextKey] && options.uppercase
          ? nextOption[optionTextKey].toUpperCase()
          : nextOption[optionTextKey];
    }
    return acc;
  }, {});
};

export const sendPageView = () => {
  if (window.ga) {
    window.ga('send', 'pageview', getCurrentPathName());
  }
};

//scroll cards container to the top used in edit-delivery
export const scrollItemsContainerToTop = () => {
  const el = document.getElementsByClassName('items-display-container')[0];
  if (el) {
    el.scroll(0, 0);
  }
};

// strips non alphanumeric chars from a string
export const stripNonAlpha = (str) => {
  return str.replace(/^\W+|\W+$/g, '');
};

export const waitFor = (ms) => new Promise((r) => setTimeout(r, ms));

export const formatDate = (date) => {
  return format(parseISO(date), 'EEEE, MMMM do');
};

// creates a function that filters the tags depending on the customer's deitary preferences:
export const createTagDietFilterFunc = (dietPrefs) => (tags) => {
  // only return the active protein tags
  return tags.filter((t) => {
    if (dietPrefs.is_vegan || dietPrefs.is_vegetarian) {
      if (MEAT_TAGS.includes(t.id) || SEAFOOD_TAGS.includes(t.id)) {
        return false;
      }
    }
    if (dietPrefs.is_pescatarian) {
      if (MEAT_TAGS.includes(t.id)) {
        return false;
      }
    }
    if (dietPrefs.is_shellfish_free) {
      if (SHELLFISH_TAGS.includes(t.id)) {
        return false;
      }
    }
    if (dietPrefs.is_soy_free) {
      if (SOY_TAGS.includes(t.id)) {
        return false;
      }
    }
    return true;
  });
};

/**
 *
 * @param {Array of tags} tagsArr
 * @returns {
 *  spicyLevel[int]: {
 *    name: t.name,
      remark: t.remark,
      thumbnail: t.thumbnail_url,
 *  }
    ... (for all tags)
 * }
 */
export const spicyTagsBySpicyLevel = (tagsArr) => {
  const spicyTagsDataFromArr = tagsArr.reduce((acc, t) => {
    let spicyLevel = SPICY_TAGS_MAP[t.id];
    acc[spicyLevel] = {
      name: t.name,
      remark: t.remark,
      thumbnail: t.thumbnail_url,
    };
    return acc;
  }, {});
  return spicyTagsDataFromArr;
};

export const makeSegmentProductList = (mappingObj, category) => {
  let store = [];
  for (const [id, obj] of Object.entries(mappingObj)) {
    store.push({
      product_id: id,
      category: category,
      count: obj.qty ? obj.qty : obj.count,
    });
  }
  return store;
};
